export class UserList {
    constructor(
      public gpn = 0,
      public activeEmployee=true,
    public firstName='',
    public  lastName='',
    public rankCode=0,
    public rankName='',
    public subServiceLine='',
      public serviceLine = '',
      public locationCity='',
    public emailId='',
    public isAdmin='',
      public isAuthorized = '',
      public picture='',
      public title='',
      public designation='',
      public linkEnglish='',
      public linkFrench='',
      public is_Display='',
      public businessUnitCode='',
      public  userId=0)
  { }
}

export class UserLogsList {
  constructor(
    public UserLogsId = 0,
    public gpn = 0,
    public activeEmployee='',
  public firstName='',
  public  lastName='',
  public rankCode=0,
  public rankName='',
  public subServiceLine='',
    public serviceLine = '',
    public locationCity='',
  public emailId='',
  public isAdmin='',
    public isAuthorized = '',
    public picture='',
    public title='',
    public designation='',
    public linkEnglish='',
    public linkFrench='',
    public is_Display='',
    public businessUnitCode='',
    public  userId=0,
    public logCreatedBy='',
    public logModifiedBy='',
    public logCreatedDate= new Date(),
    public logModifiedDate= ''
    )
{ }
}


